module.exports = __webpack_public_path__ + "assets/images/pages/stack/front.png?7e9fc3c1";